import request from "../../utils/request";
import { Result } from "../../models/general";
import { CompanyBenefitTypeView, UserBenefitView, CompanyBenefitTypeInput, UserBenefitInput } from "../../models/payroll";

export async function getCompanyBenefitTypes() {
  const response = await request.get<Result<CompanyBenefitTypeView[]>>(`Benefit/GetCompanyBenefitTypes`);
  return response.data;
}

export async function getCompanyBenefitTypesWithStats() {
  const response = await request.get<Result<CompanyBenefitTypeView[]>>(`Benefit/GetCompanyBenefitTypesWithStats`);
  return response.data;
}

export async function addCompanyBenefitType(input: CompanyBenefitTypeInput) {
  const response = await request.post<Result<CompanyBenefitTypeView>>(`Benefit/AddCompanyBenefitType`, input);
  return response.data;
}

export async function editCompanyBenefitType(benefitTypeId: number, input: CompanyBenefitTypeInput) {
  const response = await request.post<Result<CompanyBenefitTypeView>>(`Benefit/EditCompanyBenefitType/${benefitTypeId}`, input);
  return response.data;
}

export async function deleteCompanyBenefitType(benefitTypeId: number) {
  const response = await request.post<Result<CompanyBenefitTypeView[]>>(`Benefit/DeleteCompanyBenefitType/${benefitTypeId}`);
  return response.data;
}

export async function getUserBenefits(userId: string) {
  const response = await request.get<Result<UserBenefitView[]>>(`Benefit/GetUserBenefits/${userId}`);
  return response.data;
}

export async function addUserBenefit(input: UserBenefitInput) {
  const response = await request.post<Result<UserBenefitView>>(`Benefit/AddUserBenefit`, input);
  return response.data;
}

export async function editUserBenefit(benefitId: number, input: UserBenefitInput) {
  const response = await request.post<Result<UserBenefitView>>(`Benefit/EditUserBenefit/${benefitId}`, input);
  return response.data;
}

export async function deleteUserBenefit(benefitId: number) {
  const response = await request.post<Result<boolean>>(`Benefit/DeleteUserBenefit/${benefitId}`);
  return response.data;
}